module.exports = __webpack_public_path__ + "img/menulingua_logo_v2-01.0272c428.svg";